import { GifReader } from "../lib/omggif";

export const useGifDecoder = (file: File) => {
  const getFrames = async () => {
    const buffer = await file.arrayBuffer();
    const intArray = new Uint8Array(buffer);
    const reader = new GifReader(intArray);
    const { width, height } = reader.frameInfo(0);

    const frames = new Array(reader.frameCount()).fill(0).map((_, index) => {
      const image = new ImageData(width, height);

      reader.decodeAndBlitFrameRGBA(index, image.data as any);

      return image;
    });

    const frameRate = reader.frameRate();
    const frameCount = reader.frameCount();

    return {
      frames,
      width,
      height,
      frameRate,
      frameCount
    };
  };

  return {
    getFrames
  };
};
